import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const state = {
  token: getToken(),
  school:{},
  schoolItem:{},
  fotmData:{},
  idCard:''
}
const mutations = {
  SET_IDCARD: (state, idCard) =>{
    state.idCard = idCard
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_SCHOOL: (state, school) => {
    state.school = school
  },
  SET_SCHOOLITEM: (state, schoolItem) => {
    state.schoolItem = schoolItem
  },
  SET_FORMDATA: (state, fotmData) => {
    state.fotmData = fotmData
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

